<template>
	<div>
		<code-login ref="myCodeLogin" @update-page="updatePage"></code-login>
		<head-top head-title="近期直播" goBack="true"></head-top>
		<!-- tab分类：全部，我的 -->
		<div class="bg_a top flex_b color_e font_size_c fw ">
			<div class="tab_item" :class="!myStatus?'active':''" @click="switchNav(false)">全部</div>
			<div class="tab_item" :class="myStatus?'active':''" @click="switchNav(true)">我的</div>
		</div>


		<div class="paddingtopa">
			<!-- 直播课程列表 -->
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<van-list :offset="40" v-model="loading" :finished="finished" :immediate-check="false" :finished-text="finishedText"
				 @load="onLoad" v-if="broadcastList.length > 0">
					<div class="broadcast_list flex_a">
						<div v-for="(item, index) in broadcastList" :key="index" @click="tobroadcast(item.canWatch,item.curriculum.classType,item.curriculumId,item.id,item.skuId,item.chapterName)"
						 class="broadcast_item">
							<div class="chapter_name_title font_size_b fw ellipsis_1">
								{{item.chapterName}}
							</div>
							<img :src="resourceDomain + item.splitImgs[0]" class="imgs" v-if="item.splitImgs[0]" />
							<div class="zb_about flex_c color_a">
								<div v-if="item.extendStatus==2">
									直播 {{item.broadcastStartTime}}
								</div>
								<div v-if="item.extendStatus!=2" class="flex_d">
									<img :src='resourceDomain+"static/icon/living_a.gif"' class="living_gif">
									<div class="color_c">直播中</div>
								</div>
							</div>
						</div>
					</div>
				</van-list>
				<div v-else>
					<div class="color_e font_size_c paddinga" style="text-align:center;">
						<img :src='resourceDomain+"static/icon/no_order.png"' class="noorder">
						<div>暂无数据，逛逛别的分类吧~</div>
					</div>
				</div>
			</van-pull-refresh>


		</div>

	</div>
</template>

<script>
	import headTop from "@/components/common/head.vue";
	import api from "@/apis/api";
	import {
		mapGetters
	} from "vuex";
	export default {
		name: "LivingCurriculum",
		components: {
			headTop: headTop,
		},
		data() {
			return {
				resourceDomain: api.resourceDomain,
				broadcastList: [],
				token: undefined,
				myStatus: false,
				page: 0,
				pages: 0,
				isLoading: false,
				loading: false,
				finished: false,
				finishedText:''
			};
		},
		created() {},
		activated() {
			this.updatePage()
		},
		computed: {
			...mapGetters("userModule", ["getToken"]),
		},
		methods: {
			// 调用组件中的登录成功里的自定义的更新数据事件
						updatePage() {
							this.page = 0
							this.broadcastList = []
							this.token = this.getToken()
							this.loading = true
							this.isLoading= false
							this.finished = false
							this.finishedText = ""
							this.getBroadcast()
						},
						
			//tab切换，全部，我的
			switchNav: function(v) {
				this.myStatus = v;
				this.broadcastList = [];
				this.page = 0;
				this.pages = 0
				this.loading = true
				this.finished = false
				if (!(this.getToken()) && v) {
					//没登陆，点到我的里面，不走接口，数据为空
					this.$store.commit('userModule/SET_login_popup_show', true)
				} else {
					this.getBroadcast()
				}

			},

			// 获取直播课程列表
			getBroadcast() {
				var token=this.getToken()
				let url = token? '/broadcast/getBroadcast' : '/p/broadcast/getBroadcast',
					broadcastList = this.broadcastList,
					page = this.page + 1,
					myStatus = this.myStatus,
					size = 10,
					data = {}

				if (token) {
					data = {
						page: page,
						size: size,
						myStatus: myStatus
					}
				} else {
					data = {
						page: page,
						size: size
					}
				}

				this.$toast.loading({
					overlay: true,
					message: '加载中...',
					duration: 0
				})

				api.get(url, data).then(res => {
					this.$toast.clear()
					console.log(res, "-----getBroadcast------")
					if (res.code == 20000) {
						if (res.data.broadcastList.length > 0) {
							for (var i = 0; i < res.data.broadcastList.length; i++) {
								broadcastList.push(res.data.broadcastList[i])
							}
							this.page = page
							this.pages = res.data.pages
							this.broadcastList = broadcastList
							// 加载状态结束
							this.isLoading = false
							this.loading = false
							// 设置是否可以继续上拉加载
							if (this.page == this.pages) {
								this.finished = true
							} else {
								this.finished = false
							}
							this.finishedText = "没有更多了~"
						} else {
							this.finished = true
							this.finishedText = ""
							this.broadcastList = []
						}
					} else {
						this.$toast(res.message)
					}
				})
			},


			/**下拉刷新 */
			onRefresh() {
				this.page = 0;
				this.broadcastList = [];
				if (!(this.getToken()) && this.myStatus) {
					//没登陆，点到我的里面，不走接口，数据为空
					this.$store.commit('userModule/SET_login_popup_show', true)
				} else {
					this.getBroadcast()
				}
				this.isLoading = false;
			},
			/**上拉加载 */
			onLoad() {
				if (this.page == this.pages) {
					this.$toast('没有更多咯~')
				} else {
					this.getBroadcast()
				}
			},
			// 点击
			tobroadcast(canwatch, classtype, curriculumId, id, skuId, chapterName) {
				console.log(canwatch, classtype, curriculumId, id,
					"---------------------canWatch,classType,curriculumId,index,id,chapterName")
				var token = this.getToken()

				if (!token) {
					// 未登录
					this.$store.commit('userModule/SET_login_popup_show', true)
				} else {
					// 登录了
					console.log(canwatch, "-*-------------canwatch")
					if (!canwatch) {
						// 没购买 ，不免费
						this.$dialog.confirm({
							title: '提示',
							message: '该章节为付费课程，如需观看，请购买'
						}).then(() => {
							this.$router.push({
								path: '/skuCurriculum_detail',
								query: {
									curriculumId: curriculumId
								}
							})
						}).catch(() => {})
					} else {
						// 购买了或者免费：走验证接口,只能提前30分钟进直播，data里是true是超过30分钟，false是能看的
						api.get('/broadcast/judgeMintuesByChapterId', {
							chapterId: id
						}).then((res) => {
							if (res.success) {
								if (res.data) {
									// 没到三十分钟
									this.$dialog.alert({
										title: '提示',
										message: '您来早啦，直播课提前30分钟进即可~'
									}).then(() => {
										console.log('用户点击确定')
									})
								} else {// 30分钟内
									this.toBjyLivePage(id, skuId, chapterName,curriculumId,classtype);
								}
							} else {
								this.$toast(res.message)
							}
						})
					}

				}
			},

			toBjyLivePage(id, skuId, chapterName,curriculumId,classtype) {
				api.get('/p/curriculum/chapterJudgeLiveOrPlayback', {
					chapterId: id
				}).then(r => {
					// r.data:3=直播，4=回放
					if (r.data == 3) {
						if (classtype == 1) {// 大班课
							api.get('/curriculum/getBjyLivePageUrl/' + id).then((res) => {
								if (res.success) {
									location.href = res.data
								} else {
									this.$toast(res.message)
								}
							})
						} else {// 小班课
							this.$dialog.alert({
								title: '提示',
								message: '该课程为小班课，手机wap端仅提供观看聊天功能，如需享受连麦发言功能，请前往PC端'
							}).then(() => {
								api.get('/curriculum/getBjyLivePageUrl/' + id).then((res) => {
									if (res.success) {
										location.href = res.data
									} else {
										this.$toast(res.message)
									}
								})
							})
						}
					} else if (r.data == 4) {
						this.$dialog.alert({
							title: '提示',
							message: '该直播已结束，观看回放'
						}).then(() => {
							this.$router.push({
								'path': '/playback',
								query: {
									id: id,
									skuId: skuId,
									headtitle: chapterName,
									curriculumId: curriculumId
								}
							})
						})
					}
				})
			}
		},
	};
</script>
<style>
	.broadcast_list .van-count-down {
		color: #fff;
		font-size: 12px;
	}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
	.top {
		position: fixed;
		width: 100%;
		left: 0;
		right: 0;
		top: 48px;
		z-index: 999;
		height: 45px;
		line-height: 45px;
		letter-spacing: 1px;
	}

	/* 教师资格和教师招聘选择 */
	.tab_item {
		position: relative;
		height: 45px;
		line-height: 45px;
	}

	.tab_item.active {
		color: #3b7bfd;
	}

	.tab_item.active::after {
		content: '';
		width: 25px;
		height: 3px;
		background-color: #3b7bfd;
		border-radius: 1.5px;
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
	}


	/* 热门课程 */
	/* 搜索开始 */
	img {
		display: block;
	}

	.paddingtopa {
		padding: 93px 0 15px;
	}

	.paddinga {
		text-align: center;
		padding: 15px 0;
	}

	.noorder {
		width: 345px;
		height: 172.5px;
		margin: 15vh auto 25px;
	}

	.broadcast_list {
		width: 345px;
		padding: 10px 15px 0;
		flex-wrap: wrap;
	}

	.broadcast_item {
		width: 165px;
		margin-right: 15px;
		margin-bottom: 15px;
		border-radius: 5px;
		position: relative;
	}

	.broadcast_item:nth-child(2n) {
		margin-right: 0;
	}

	.chapter_name_title {
		height: 19px;
		background-color: #f5f5f5;
		width: 149px;
		padding: 5px 8px;
		border-radius: 5px 5px 0 0;
		line-height: 19px;
	}

	.imgs {
		width: 165px;
		height: 82.5px;
	}



	.zb_about {
		font-size: 11px;
		width: 149px;
		background-color: rgba(0, 0, 0, .2);
		padding: 5px 8px;
		border-radius: 0 0 5px 5px;
	}

	.living_gif {
		width: 14px;
		height: 14px;
		margin-right: 5px;
	}
</style>
